import { z } from '@/libs/zod';

import { LuckySequencyType, PrizeType } from '../enums';

export const prizeSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: PrizeType,
  isDrawn: z.boolean(),
  prizeValue: z.number(),
});

export const ticketSchema = z.object({
  hasBeenScratched: z.boolean(),
  id: z.string(),
  name: z.string().optional(),
  prizes: z.array(prizeSchema),
  sequence: z.string(),
  winning: z.boolean(),
});

export const purchasedRaffleSchema = z.object({
  drawDate: z.string(),
  id: z.string(),
  lastPurchase: z.string(),
  maxTicketsPerCpf: z.number(),
  model: z.object({
    luckySequencyType: LuckySequencyType,
  }),
  name: z.string(),
  numbering: z.number(),
  redirectRaffleUrl: z.string().nullable(),
  status: z.string(),
  tickets: z.array(ticketSchema),
  ticketsBought: z.number(),
  urlFacebook: z.string().nullable(),
  urlThumbnail: z.string(),
  urlRouletteBanner: z.string(),
  urlWhatsapp: z.string().nullable(),
});

export const userSchema = z.object({
  name: z.string(),
  cpf: z.string(),
  phone: z.string(),
});

export const purchasedRafflesResponseSchema = z.object({
  data: z.array(purchasedRaffleSchema),
  totalCount: z.number(),
  user: userSchema,
  prizeNames: z.array(z.string()).optional(),
  prizeValues: z.array(z.number()).optional(),
});

export type Prize = z.infer<typeof prizeSchema>;
export type Ticket = z.infer<typeof ticketSchema>;
export type PurchasedRaffle = z.infer<typeof purchasedRaffleSchema>;
export type User = z.infer<typeof userSchema>;
export type PurchasedRafflesResponse = z.infer<typeof purchasedRafflesResponseSchema>;

export type PurchasedRafflesParams = {
  skip: number;
  take: number;
  cpf: string;
  phone: string;
  current: boolean;
};
